import util from 'util';

declare global {
    interface Console {
        logDeep(obj: unknown, depth?: number): void;
    }
}

console.logDeep = function (obj: unknown, depth: number = 3) {
    console.log(util.inspect(obj, { colors: true, depth: depth }));
};
